import { StampType } from 'components/Viewer/types';
import React, { useEffect, useRef, useState } from 'react';

import { msToTime } from '../../../../helpers/helpers';

const Stamp = ({ stamp, minTime, range, maxWidth }:{stamp:StampType, minTime:number, range:number, maxWidth: number}) => {
  const label = useRef(null);
  const time = useRef(null);
  const [positionLabelPx, setPositionLabelPx] = useState(0);
  const [positionTimePx, sePositionTimePx] = useState(0);
  const percentageLeftPosition = ((stamp.timeStamp - minTime) / range) * 100;
  const pixelLeftPosition = percentageLeftPosition * maxWidth / 100;
  useEffect(() => {
    if (label.current) {
      //@ts-ignore
      setPositionLabelPx(pixelLeftPosition + label.current.offsetWidth);
    }
    if (time.current) {
      sePositionTimePx(pixelLeftPosition + 70);
    }
  }, [range, minTime, stamp]);
  return (
    <div
      className={stamp.type === 'period' ? 'time-line-stamp-with-line-up' : stamp.shape === 'circle' ? 'time-line-stamp-with-circle' : 'time-line-stamp-with-square'}
      style={{ left: `${pixelLeftPosition}px` }}
      key={JSON.stringify(stamp)}
    >
      {stamp.type === 'period' ? (
        <label
          className={'time-line-label-period' + (Math.min(maxWidth - positionTimePx, 5) < 5 ? ' time-line-label-period-right' : '')}
          ref={time}
          style={{ left: `${Math.min(maxWidth - positionTimePx, 5)}px` }}
        >
          <b>{stamp.name}</b> <br />
          ({msToTime(stamp.timeStamp - minTime)}-{msToTime(stamp.timeStampEnd as number - minTime)})
        </label>
      ) : (
        <label
          className="time-line-label-type"
          ref={label}
          style={{ left: `${Math.min(maxWidth - positionLabelPx, 0)}px` }}
        >
          <b>{stamp.type}</b> <br />
          {msToTime(stamp.timeStamp - minTime)}
        </label>
      )}
    </div>
  );
};
export default Stamp;
